import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import jMoment from "moment-jalaali";

import { Container, Row, Col } from "reactstrap";

import { getDashboardReports } from "../../store/actions/dashboard";

import Reports from "../../components/Reports/index";
import NewUsersReport from "../../components/Reports/NewUsersReport";
import OfflineReport from "../../components/Reports/OfflineReport";

import { enDigits } from "../../utils/formatDigits";

const Dashboard = props => {
  useEffect(() => {
    if (!props.reports) props.getDashboardReports({
      startDate: enDigits(jMoment().subtract(1, 'day').format('jYYYY-jM-jD')),
      endDate: enDigits(jMoment().subtract(1, 'day').format('jYYYY-jM-jD'))
    });
  });
  return (
    <Container fluid>
      <Row>
        <Col xs="12" lg="6">
          <NewUsersReport />
        </Col>
        <Col xs="12" lg="6">
          <OfflineReport />
        </Col>
      </Row>
      <h4 className="mb-4">آمار کلی از دیروز تا الان</h4>
      <Reports
        data={props.reports}
        singles={[
          'clickCount',
          'playCount',
          'durationSum',
          'skipSum',
          'likeCount',
          'unlikeCount'
        ]}
        topTrends={[
          'topTrackDurations',
          'topArtistLikes',
          'topChannelClicks',
          'topChannelListens'
        ]}
      />
    </Container>
  )
}


export default connect(
  state => (
    {
      reports: state.dashboard.reports
    }
  ),
  dispatch => bindActionCreators({
    getDashboardReports
  }, dispatch)
)(Dashboard)